import * as actions from './actions';
import * as dealActions from '../deal/actions';
import { addTaskAttachment, deleteTaskAttachment } from 'bundles/apex/tasks/helpers';

const initialState = null;

export default function(state = initialState, action) {
  switch (action.type) {

  case actions.SET_TASKS:
    return action.tasks;

  case dealActions.SET_DEAL:
    return action?.deal?.tasks;

  case actions.ADD_TASK:
    return [...state, action.task];

  case actions.DELETE_TASK:
    return state.filter(task => task.id !== action.task.id);

  case actions.UPDATE_TASK:
    return state.map(task => task.id === action.task.id ? action.task : task);

  case actions.ADD_TASK_ATTACHMENT:
    return state.map((task) => {
      return task.id === action.task.id ? addTaskAttachment(action.task, action.attachment) : task;
    });

  case actions.DELETE_TASK_ATTACHMENT:
    return state.map((task) => {
      return task.id === action.task.id ? deleteTaskAttachment(action.task, action.attachment) : task;
    });

  // Changes to contacts may result in task tags being changed on the backend - to keep things
  // simple, force tasks to be reloaded when that may happen
  case dealActions.CHANGE_CONTACT_ROLE:
  case dealActions.UPDATE_CONTACT:
    return null;

  default:
    return state;
  }
}
